var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupChannel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8875_7602)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.5 33C65.5 50.9493 50.9493 65.5 33 65.5C15.0507 65.5 0.5 50.9493 0.5 33C0.5 15.0507 15.0507 0.5 33 0.5C50.9493 0.5 65.5 15.0507 65.5 33Z",
    fill: "#E0E0E0",
    stroke: "#E04052"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2943 40.0345L43.8482 37.0186L54.0312 43.1168L52.4773 46.1328L42.2943 40.0345Z",
    fill: "#E04052"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2962 22.9651L52.4792 16.8662L54.0332 19.8822L43.8501 25.9811L42.2962 22.9651Z",
    fill: "#E04052"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7781 29.7832H56.4261V33.2332H44.7781V29.7832Z",
    fill: "#E04052"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8696 38.7C30.2696 38.7 39.8696 45.6 39.8696 45.6V18C39.8696 18 30.2696 24.9 23.8696 24.9V38.7Z",
    fill: "#E04052"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2 24.5996H15.8C12.2653 24.5996 9.40002 27.6887 9.40002 31.4996C9.40002 35.3105 12.2653 38.3996 15.8 38.3996C15.8 43.3635 16.3767 48.2956 17.5146 53.06L23.7123 51.3399C22.7088 47.1371 22.2 42.7839 22.2 38.3996V24.5996Z",
    fill: "#E04052"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8875_7602"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 66,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupChannel);
export default __webpack_public_path__ + "static/media/group-channel.543164e09bdb76369ba67d60cd541cf1.svg";
export { ForwardRef as ReactComponent };